import React, { Component } from "react";

import { MDBBtn, MDBSpinner, MDBModal, toast } from "mdbreact";

import VenueKeypoolsTable from "../../../components/NetworkMgmt/Venues/Datatables/VenueKeypoolsTable";

import AddKeypool from "../../../components/NetworkMgmt/Forms/AddKeypool/AddKeypool";

import { withTranslation } from "react-i18next";

import axios from "../../../axios";

class ViewVenueKeypools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            loading: false,
            modalAddServicePlan: false,
            loadingRemoveSSID: false,
            removingSSID: null,
            disabled:
                sessionStorage.getItem("customerSupport") > 0 ? true : false,
        };
    }

    toggleAddKeypool = () => {
        this.setState({
            modalAddKeypool: !this.state.modalAddKeypool,
        });
    };

    removeUnitSSID = (ssid, unitIDInternal) => {
        this.setState({ loadingRemoveSSID: true, removingSSID: ssid });
        // Use keyPoolList to find all SSIDs assigned to this unit (matching Scope = unitIDInternal)
        // then remove the specified one and send the remaining list
        let existingSSIDs = [];
        if (this.props.keyPoolList) {
            Object.keys(this.props.keyPoolList).forEach(key => {
                const keypool = this.props.keyPoolList[key];
                if (keypool["Scope"] === unitIDInternal) {
                    existingSSIDs.push(keypool["ssid"]);
                }
            });
        }

        // Remove the SSID from the list
        const updatedSSIDs = existingSSIDs.filter(s => s !== ssid);

        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            UnitID_internal: unitIDInternal,
            NetworkConfiguration: {
                VenueUnitSSID: updatedSSIDs,
            },
        };

        axios
            .post("/operatorconsole/venues/configureVenueUnit", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success(response?.data?.message || "There was an error removing the SSID!", {
                        closeButton: false,
                    });
                    this.setState({ loadingRemoveSSID: false, removingSSID: null });
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                },
                (error) => {
                    toast.error(error?.response?.data?.message || "There was an error removing the SSID!", {
                        closeButton: false,
                    });
                    this.setState({ loadingRemoveSSID: false, removingSSID: null });
                }
            );
    };

    submitAddKeypool = (ssid, venueID, scope, displayOrder, keypoolRole, selectedUnit, existingUnitSSIDs = []) => {
        this.setState({ add_keypool: true });

        if (keypoolRole === "unit") {
            // Use the existing SSIDs passed directly from the form (already looked up)
            let updatedSSIDs = [...existingUnitSSIDs];

            // Add the new SSID if it's not already in the list
            if (!updatedSSIDs.includes(ssid)) {
                updatedSSIDs.push(ssid);
            }

            // Enforce a maximum of 4 Unit Level SSIDs per unit (NETWORKUI-722)
            if (updatedSSIDs.length > 4) {
                toast.error("A maximum of 4 Unit Level SSIDs are allowed per unit.", {
                    closeButton: false,
                });
                this.setState({ add_keypool: false });
                return;
            }

            let body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                UnitID_internal: selectedUnit,
                NetworkConfiguration: {
                    VenueUnitSSID: updatedSSIDs,
                },
            };

            axios
                .post("/operatorconsole/venues/configureVenueUnit", body, {
                    headers: {},
                })
                .then(
                    (response) => {
                        toast.success(response.data.message || "Unit keypool configured successfully!", {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.props.updateName(
                            this.props.venueName,
                            this.props.venueID
                        );
                        this.props.getVenueDetails(this.props.venueID);
                        this.setState({ add_keypool: false });
                    },
                    (error) => {
                        toast.error(error?.response?.data?.message || "There was an error!", {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.setState({ add_keypool: false });
                    }
                );
        } else {
            // Global or Venue keypool: use addKeypool API
            let body;
            if (scope === "global") {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    SSID: ssid,
                    Scope: scope,
                    DisplayOrder: displayOrder,
                };
            } else {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    SSID: ssid,
                    VenueID: this.props.venueID,
                    DisplayOrder: displayOrder,
                };
            }

            axios
                .post("/networkoperatorconsole/keypools/addKeypool", body, {
                    headers: {},
                })
                .then(
                    (response) => {
                        toast.success(response.data.message, {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.props.updateName(
                            this.props.venueName,
                            this.props.venueID
                        );
                        this.props.getVenueDetails(this.props.venueID);
                        this.setState({ add_keypool: false });
                    },
                    (error) => {
                        toast.error("There was an error!", {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.setState({ add_keypool: false });
                    }
                );
        }
    };

    submitAssignKeypool = (keypoolID, venueID, ssid) => {
        this.setState({ add_keypool: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyPoolID: keypoolID,
            connectVenueID: this.props.venueID,
        };

        axios
            .post("/networkoperatorconsole/keypools/configureKeypool", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Keypool assigned successfully!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ add_keypool: false });
                },
                (error) => {
                    toast.error(error?.response?.data?.message || "There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.setState({ add_keypool: false });
                }
            );
    };

    render() {
        return (
            <>
                {this.state.loadingRemoveSSID && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                padding: "2rem",
                                textAlign: "center",
                                minWidth: "220px",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                            }}
                        >
                            <MDBSpinner />
                            <p className="mt-3 mb-0">
                                Removing <strong>{this.state.removingSSID}</strong>...
                            </p>
                        </div>
                    </div>
                )}
                <MDBModal
                    isOpen={this.state.modalAddKeypool}
                    toggle={this.toggle}
                    size="md"
                    className="form"
                    centered
                >
                    <AddKeypool
                        toggleAddKeypool={this.toggleAddKeypool}
                        venueName={this.props.venueName}
                        submitAddKeypool={this.submitAddKeypool}
                        add_keypool={this.state.add_keypool}
                        loadingAddKeypool={this.state.loadingAddKeypool}
                        localOnly={true}
                        allKeypools={this.props.allKeypools}
                        keyPoolList={this.props.keyPoolList}
                        Units-Building-Floor-List-Subscribers={this.props["Units-Building-Floor-List-Subscribers"]}
                    />
                </MDBModal>
                {this.props.keyPoolList !== undefined ? (
                    <>
                        <div className="servicePlans">
                            <VenueKeypoolsTable
                                keyPoolList={this.props.keyPoolList}
                                refreshed={this.props.refreshed}
                                disablePlanConfirm={
                                    this.props.disablePlanConfirm
                                }
                                removeUnitSSID={this.removeUnitSSID}
                                loadingRemoveSSID={this.state.loadingRemoveSSID}
                                Units-Building-Floor-List-Subscribers={this.props["Units-Building-Floor-List-Subscribers"]}
                            />
                        </div>
                    </>
                ) : (
                    <MDBSpinner small />
                )}
                <MDBBtn
                    color="danger"
                    onClick={this.toggleAddKeypool}
                    className="btn-right"
                    disabled={this.state.disabled}
                >
                    Add Keypool
                </MDBBtn>
            </>
        );
    }
}

export default withTranslation()(ViewVenueKeypools);
